import type { Config } from '@ms/yammer-data/dist/state/types';

type GetConfig = () => Promise<Config>;
export const getConfig: GetConfig = async () => window.__yammerconfig__ as Config;
